import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useReviewAccount } from "@/hooks/useReviewAccount";
import { SplashScreen } from "@/components/SplashScreen";
import { AccessDenied } from "@/components/auth/AccessDenied";

/** /revisao: only the server-flagged review account; everyone else goes back. */
export function ReviewRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, signOut } = useAuth();
  const { isReview, isLoading, isError, retry } = useReviewAccount();
  if (loading || isLoading) return <SplashScreen message="Carregando" />;
  if (!user) return <Navigate to="/auth" replace />;
  if (isError) return <AccessDenied permissionCheckFailed onRetry={async () => retry()} onExit={signOut} />;
  if (!isReview) return <Navigate to="/" replace />;
  return <>{children}</>;
}
